import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { 
  FaHome, 
  FaSearch, 
  FaArrowLeft, 
  FaExclamationTriangle,
  FaCreditCard,
  FaPiggyBank,
  FaHandHoldingUsd
} from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  const quickLinks = [
    { name: 'Home', path: '/', icon: FaHome },
    { name: 'Checking Accounts', path: '/checking', icon: FaCreditCard },
    { name: 'Savings Accounts', path: '/savings', icon: FaPiggyBank },
    { name: 'Loans', path: '/loans', icon: FaHandHoldingUsd },
  ];

  return (
    <>
      <Helmet>
        <title>Page Not Found - GN Bank</title>
        <meta name="description" content="The page you're looking for doesn't exist. Redirecting to GN Bank homepage." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="not-found-container">
        <Container>
          <div className="not-found-content">
            {/* Animated 404 Number */}
            <div className="not-found-number">
              <span className="number-4">4</span>
              <span className="number-0">0</span>
              <span className="number-4">4</span>
            </div>

            {/* Error Icon */}
            <div className="not-found-icon">
              <FaExclamationTriangle />
            </div>

            {/* Main Message */}
            <h1 className="not-found-title">Page Not Found</h1>
            <p className="not-found-description">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
            <p className="not-found-subdescription">
              Don't worry, we'll redirect you to the homepage in <strong>{countdown}</strong> seconds.
            </p>

            {/* Action Buttons */}
            <div className="not-found-actions">
              <button
                type="button"
                className="btn btn-gn-primary not-found-btn"
                onClick={handleGoHome}
              >
                <FaHome className="me-2" />
                Go to Homepage
              </button>
              <button
                type="button"
                className="btn btn-gn-secondary not-found-btn"
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft className="me-2" />
                Go Back
              </button>
            </div>

            {/* Quick Links */}
            <div className="not-found-quick-links">
              <h3 className="quick-links-title">Popular Pages</h3>
              <div className="quick-links-grid">
                {quickLinks.map((link) => {
                  const IconComponent = link.icon;
                  return (
                    <button
                      key={link.path}
                      className="quick-link-card"
                      onClick={() => navigate(link.path)}
                    >
                      <div className="quick-link-icon">
                        <IconComponent />
                      </div>
                      <span className="quick-link-text">{link.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Help Text */}
            <div className="not-found-help">
              <p>
                Need help? <a href="/contact" className="help-link">Contact our support team</a> or{' '}
                <a href="/location" className="help-link">find a branch near you</a>.
              </p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default NotFound;

